﻿import React, { useState, useEffect } from 'react';
import { SolventConfiguration } from '../../models/Solvents/solvent-configuration';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Sorting,
    HeaderFilter,
    FilterRow
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

export interface Props {
    onApplySelection?: (item: SolventConfiguration) => void;
    onCancel?: () => void;
}

export default function SolventsLookup(props: Props) {
    const [searchString, setSearchString] =
        useState<string>();

    const [solvents, setSolvents] =
        useState<SolventConfiguration[]>();

    const [selectedSolvent, setSelectedSolvent] =
        useState<SolventConfiguration>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getSolvents();
    }, []);

    return (
        <div className="pw-form-section">
            {/*
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Search</label>
                    <TextBox id="description"
                        className="textbox"
                        onValueChanged={searchStringValueChanged}
                        showClearButton={true}
                        placeholder="search" value={searchString ? searchString : undefined} />
                </div>
                <div className="pw-right-align-content">
                    <Button id="searchButton" text="Search" icon="find" type="success"
                        className="pw-button"
                        hint="search"
                        height={'2.8em'}
                        onClick={onSearch} />
                </div>
            </div>
            */}

            <div className="pw-comp-row pw-margin-left-05">
                <DataGrid className="pw-no-max-width"
                    height="16rem"
                    width="100%"
                    dataSource={solvents ? solvents : []}
                    onSelectionChanged={solventSelectionChanged}
                    keyExpr="solventConfigurationId"
                    wordWrapEnabled={true}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <Sorting mode="none" />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />

                    <Column dataField='macolaSolvent' caption="Macola Solvent" dataType="string" width='20%' />
                    <Column dataField='density' dataType="number" width='15%' />
                    <Column dataField='solventString' dataType="string" width='65%' />

                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button" disabled={!selectedSolvent}
                        text="Apply" type="success"
                        hint="apply selection"
                        height='2.6em'
                        onClick={onApplyClick} />

                    <Button id="cancelButton" 
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height='2.6em'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onApplyClick(e: any) {
        if (selectedSolvent) {
            
            if (props.onApplySelection)
                props.onApplySelection(selectedSolvent);
        }
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function solventSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedSolvent(e.selectedRowsData[0]);
        }
    }
    
    //GET functions

    async function getSolvents() {
        await CrudFunctions.getData("methods/solvents")
            .then(data => {
                setSolvents(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Solvents");
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

